// removed by extract-text-webpack-plugin
module.exports = {"button":"AnswerIcon__button__njLmN","red":"AnswerIcon__red__3nSmL","green":"AnswerIcon__green__P3l6O","singleAnswer":"AnswerIcon__singleAnswer__1eHFw","answerLabel":"AnswerIcon__answerLabel__2oUMd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AnswerIcon/AnswerIcon.css
// module id = 540
// module chunks = 0